export default __webpack_public_path__ + "locales/ja-JP/JavascriptSdk.json?hash=b5da54d1b8156a6ac2ae4d78c26cdb67";